import ApiHelper, { axiosInstance } from './index';
import { getAuthConfig } from './config';

const getConfigFields = async (category = '', spinner = true) => {
  const query = category ? `?category=${category}` : '';
  return await ApiHelper.get(`device/user_config_fields/${query}`, spinner);
};

const createConfigField = async (payload, spinner = true) => {
  return await ApiHelper.post('device/user_config_fields/', payload, spinner);
};

const deleteConfigField = async (key, spinner = true) => {
  return await ApiHelper.remove(`device/user_config_fields/${key}/`, spinner);
};

const getDeviceConfig = async (deviceId, spinner = true) => {
  return await ApiHelper.get(`device/user_config/${deviceId}/`, spinner);
};

const updateDeviceConfig = async (deviceId, payload, spinner = true) => {
  return await ApiHelper.put(
    `device/user_config/${deviceId}/`,
    payload,
    spinner
  );
};

const resetDeviceConfig = async (deviceId, keys, spinner = true) => {
  const config = getAuthConfig();
  try {
    const { data } = await axiosInstance.delete(
      `device/user_config/${deviceId}/`,
      { ...config, data: { keys } }
    );
    return [null, data];
  } catch (error) {
    return [error];
  }
};

export default {
  getConfigFields,
  createConfigField,
  deleteConfigField,
  getDeviceConfig,
  updateDeviceConfig,
  resetDeviceConfig,
};
